import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import IconBox from 'components/icons/IconBox';

const styles = () => ({
  root: {
    height: 330,
  },
  iconBox: {
    width: 105,
    height: 105,
  },
});

const HCPCSCodesTableEmpty = ({ classes }) => (
  <Grid
    className={classes.root}
    container
    direction="column"
    justify="center"
    alignItems="center"
    spacing={24}
  >
    <Grid item>
      <IconBox className={classes.iconBox} />
    </Grid>
    <Grid item>
      <Typography variant="subheading" color="secondary">
        Unfortunately, there are no such HCPCS Codes
      </Typography>
    </Grid>
  </Grid>
);

HCPCSCodesTableEmpty.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    iconBox: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(HCPCSCodesTableEmpty);



// WEBPACK FOOTER //
// ./src/components/settings/HCPCSCodesTable/HCPCSCodesTableEmpty.js